export const IsLoggedIn=()=>{
    return {
        type:'SIGN_IN'
    }
}
export const User=(response)=>{
    return {
        type:'USER_DATA',
        payload:response
    }
}
export const FixtureData=(response)=>{
    return {
        type:'FIXTURES',
        payload:response

    }
}
export const FixtureADD=(response)=>{
    return {
        type:'FIXTURE_ADD',
        payload:response

    }
}
export const FixturePrepend=(response)=>{
    return {
        type:'FIXTURE_PREPEND',
        payload:response
    }
}
export const QuestionData=(response)=>{
    return {
        type:'QUESTION',
        payload:response

    }
}
export const LeaderBoardList=(response)=>{
    return {
        type:'LEADERBOARD',
        payload:response

    }
}
export const LeaderBoardAdd=(response)=>{
    return {
        type:'LEADERBOARD_ADD',
        payload:response

    }
}

export const UpdateSiteStatus = (data)=>{
    return { type: data ==="under_maintenance" ? "SET_MAINTENANCE_ON": "SET_MAINTENANCE_OFF"  } 
}

export const SiteUnderMaintenance = ()=>{
    return { type: "SET_MAINTENANCE_ON"  }  
}

export const UpdateWeekDays =(data) =>{
    return {type: "SET_WEEK_DAYS",payload:data}
}

export const SetLeaderBoardTabs = (tab) => ({
    type: "SET_TAB",
    payload: tab,
  });
  
  export const SetWeekDay = (week) => ({
    type: "SET_WEEK_DAY",
    payload: week,
  });
  
  export const RemoveWeekDay = () => ({
    type: "REMOVE_WEEK_DAY",
  });
  
  export const SetDailyDate = (date) => ({
    type: "SET_DAILY_DATE",
    payload: date,
  });
  
  export const RemoveDailyDate = () => ({
    type: "REMOVE_DAILY_DATE",
  });

  // --- DAY ---
export const SetDay = (day) => ({
    type: "SET_DAY",
    payload: day,
  });
  
  export const RemoveDay = () => ({
    type: "REMOVE_DAY",
  });
  
  // --- BOTH DATE + DAY ---
  export const SetDateAndDay = (date, day) => ({
    type: "SET_DATE_AND_DAY",
    payload: { date, day },
  });
  
  export const RemoveDateAndDay = () => ({
    type: "REMOVE_DATE_AND_DAY",
  });


  export const SetSettings = (settings) => ({
    type: "SET_SETTINGS",
    payload: settings,
  })
  